module.exports = __webpack_public_path__ + "img/mm-logo.51e21ddb.png";